import { AppDispatch, RootState } from '../index';
import { FetchState } from '../fetchState';
import { baseSlice, BaseType, getItem } from '../baseHelper';
import { CompanyBusinessSettings } from '@api/models/settings/CompanyBusinessSettings';
import { companySettingsService } from '@api/services/services';

export type CompanyCustomizationState = BaseType<CompanyBusinessSettings | undefined>;

const initialState: CompanyCustomizationState = {
  state: FetchState.None,
  data: undefined,
};

export const companyCustomizationSlice = baseSlice({
  name: 'companyCustomization',
  initialState,
});

export const selectCompanyCustomizationState = (state: RootState) => state.companyCustomization.state;
export const selectCompanyCustomization = (state: RootState) => state.companyCustomization.data;
export const selectCompanyCustomizationTrainingLangCodes = (state: RootState) => state.companyCustomization.data?.testLanguages;
export const companyCustomizationActions = companyCustomizationSlice.actions;

export const getCompanyCustomization = () => (dispatch: AppDispatch) => {
  const handleGetData = () => {
    return companySettingsService.getBusinessSettings();
  };

  getItem({
    dispatch,
    actions: companyCustomizationActions,
    getData: handleGetData,
  });
};
